const isImageByFileName = (text: string) => {
  return (
    text?.toLowerCase()?.includes('.jpg') || text?.toLowerCase()?.includes('.jpeg') || text?.toLowerCase()?.includes('.png')
  )
}

export default isImageByFileName
